import * as React from "react";
const IconWarning40 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="#D7DBF5"
      d="m33.858 32.03-19.746 5.294c-2.656.716-5.37-.866-6.086-3.523L2.732 14.056c-.716-2.657.867-5.37 3.523-6.086l19.746-5.295c2.657-.716 5.37.867 6.086 3.524l5.294 19.745a4.99 4.99 0 0 1-3.523 6.086Z"
    />
    <path
      fill="#141938"
      d="M24.305 1.112 10.57 18.03a1.648 1.648 0 0 0 .396 2.525l21.441 12.378c1.262.735 2.789-.452 2.393-1.865L27.15 2.355A2.506 2.506 0 0 0 25.963.848a1.325 1.325 0 0 0-1.658.264Z"
    />
    <path
      fill="#141938"
      d="M22.892 1.846 24.644.83l9.383 32.087-1.752.998-9.383-32.068Z"
    />
    <path
      fill="#FAFBFF"
      d="M22.61 2.072 8.873 18.992a1.647 1.647 0 0 0 .396 2.525l21.441 12.36c1.263.734 2.789-.453 2.393-1.866l-7.63-28.695a2.506 2.506 0 0 0-1.188-1.507 1.352 1.352 0 0 0-1.677.263Z"
    />
    <path
      fill="#FAAF37"
      d="M22.911 4.522 11.098 19.35a.845.845 0 0 0 .207 1.3l18.634 10.758c.49.283 1.093-.17.923-.716L24.06 4.9a.816.816 0 0 0-.376-.49c-.245-.151-.566-.094-.773.113Z"
    />
    <path
      fill="#FF1C44"
      d="M23.59 10.193c.527.283.527.942.395 1.394l-1.677 7.5c-.132.414-.452.583-.829.376-.377-.207-.622-.678-.584-1.13l.433-8.234c.038-.49.49-.848.924-.697l1.337.791ZM21.29 20.5c-.79-.302-1.469.075-1.62.847v.038c-.15.772.32 1.582 1.112 1.865.791.302 1.47-.075 1.62-.848v-.037c.151-.754-.339-1.564-1.111-1.866Z"
    />
  </svg>
);

export default IconWarning40;

